module.exports = __webpack_public_path__ + "static/media/Протокол от проведеното на 30.12.2024 г. ОСА на Формопласт АД.f03589f3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2024/Протокол от проведеното на 30.12.2024 г. ОСА на Формопласт АД.pdf
// module id = 88
// module chunks = 0